import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "./AuthContext";
import { errText } from "../lib/api";
import { useSeo } from "../lib/ui";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useSeo({ title: "Admin — Kick Start Kenya Football" });

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(form.email, form.password);
      navigate("/admin");
    } catch (err) {
      setError(errText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#050505] px-5" data-testid="admin-login-page">
      <div className="w-full max-w-sm border border-zinc-900 bg-ink-surface p-9">
        <Lock size={20} className="text-maasai" />
        <h1 className="display-3 mt-6">Admin access</h1>
        <p className="body-copy mt-2">Sign in to manage players, news and plans.</p>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <input
            required
            type="email"
            className="field"
            placeholder="Email"
            aria-label="Email"
            data-testid="admin-email-input"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <input
            required
            type="password"
            className="field"
            placeholder="Password"
            aria-label="Password"
            data-testid="admin-password-input"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          {error ? (
            <p className="text-xs text-kenya-red" data-testid="admin-login-error">{error}</p>
          ) : null}
          <button type="submit" disabled={busy} className="btn-primary w-full justify-center disabled:opacity-60" data-testid="admin-login-submit">
            {busy ? <Loader2 className="animate-spin" size={14} /> : null} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
